import { Box, Loader, TextButton, Tooltip } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus } from '@wix/rules-panel-ui';
import { SparklesFilledSmall } from '@wix/wix-ui-icons-common';
import { useAtomValue } from 'jotai';
import React from 'react';
import { altTextScreenPageIdAtom } from '../../../../atoms/session-atoms';
import { BiCtaNames } from '../../../../bi/types';
import { useBiLogger } from '../../../../hooks/use-bi-logger';
import { useSuggestionsData } from '../../../../hooks/use-suggestions-data';
import { PanoramaErrorNames } from '../../../../panorama/constants';
import { usePanoramaFunctions } from '../../../../panorama/use-panorama-functions';
import { resizeImageUrl } from '../../../../utils/resize-image-url';
import { getDisabledButtonTooltipTranslationKeySuffix } from '../utils/get-disabled-button-tooltip-translation-key-suffix';
export const GenerateWithAiSuffixButton = _ref => {
  let {
    id,
    url,
    entityId,
    status,
    index,
    handleChange,
    setToolTipMessage
  } = _ref;
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    reportErrorPanorama
  } = usePanoramaFunctions();
  const altTextScreenProps = useAtomValue(altTextScreenPageIdAtom);
  const {
    itemType
  } = altTextScreenProps || {};
  const {
    getSingleSuggestionsData
  } = useSuggestionsData();
  const disabledTooltipTranslationKeySuffix = getDisabledButtonTooltipTranslationKeySuffix([{
    url
  }]);
  const isGenerating = status === ElementStatus.Loading;
  const handleGenerateWithAiClick = async () => {
    handleChange(ElementStatus.Loading);
    biLogger.taskElementCtaClick({
      ctaName: BiCtaNames.Generate,
      index,
      status
    });
    const {
      suggestions,
      errorMessage
    } = await getSingleSuggestionsData(itemType ?? '', {
      entityId,
      id,
      url: await resizeImageUrl(url)
    });
    if (suggestions && suggestions.length > 0) {
      handleChange(ElementStatus.Generated, suggestions[0]);
    } else {
      handleChange(ElementStatus.Warning);
      if (errorMessage) {
        setToolTipMessage == null || setToolTipMessage(errorMessage);
      }
      reportErrorPanorama(new Error('Failed to generate alt text suggestions'), PanoramaErrorNames.altTextOnGenerateSingleWithAi);
    }
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: /*#__PURE__*/React.createElement(Box, {
      align: "left",
      direction: "vertical",
      gap: "SP2"
    }, disabledTooltipTranslationKeySuffix && t(`accessibility-wizard.alt-text.generate-with-ai-button.tooltip.description.${disabledTooltipTranslationKeySuffix}`)),
    disabled: !disabledTooltipTranslationKeySuffix,
    size: "small",
    onShow: () => {
      biLogger.tooltipView({
        tooltipName: disabledTooltipTranslationKeySuffix
      });
    }
  }, /*#__PURE__*/React.createElement(Box, {
    maxWidth: "120px"
  }, /*#__PURE__*/React.createElement(TextButton, {
    disabled: isGenerating || !!disabledTooltipTranslationKeySuffix,
    prefixIcon: isGenerating ? /*#__PURE__*/React.createElement(Box, {
      paddingRight: "3px"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "tiny"
    })) : /*#__PURE__*/React.createElement(SparklesFilledSmall, null),
    size: "tiny",
    ellipsis: true,
    onClick: handleGenerateWithAiClick
  }, isGenerating ? t('accessibility-wizard.alt-text.generate-with-ai-button.generating-single') : t('accessibility-wizard.alt-text.generate-with-ai-button.cta'))));
};
//# sourceMappingURL=generate-with-ai-suffix-button.js.map